import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "address",
    sortable: true,
    searchable: true,
    type: "text",
  },
  {
    name: "description",
    sortable: true,
    searchable: true,
    type: "text",
  },
];

export default function List() {
  return <ResourceListPage url="facilities" columns={columns} />;
}
